import React from 'react';
import {
  Form,
  Input,
  DatePicker,
  InputNumber,
  Checkbox,
  Divider,
  Select,
} from 'antd';

import FieldUpload from './FieldUpload';

class SpecialistPaymentInformation extends React.Component {
  render() {
    return (
      <Form name="specialist-payment-information">
        <Form.Item className="fluid-field" label="Doctor">
          <Input size="large" disabled />
        </Form.Item>
        <Form.Item label="Specialist Invoice No">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Invoice Date">
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item label="Amount (excl GST)">
          <InputNumber
            size="large"
            formatter={value =>
              `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <Form.Item label="GST">
          <InputNumber
            size="large"
            formatter={value =>
              `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <FieldUpload
          uploadLoading={false}
          attachments={null}
          label="Attached Doctor Invoice"
        />
        <div className="fluid-field checkbox-field">
          <Checkbox>Email Invoice to Operator</Checkbox>
        </div>

        <Divider className="fluid-field" />
        <div className="fluid-field checkbox-field">
          <Checkbox>Prepayment Required</Checkbox>
        </div>
        <Form.Item
          label={
            <React.Fragment>
              PIC
              <button className="field-actions">Recent changes</button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Thomas Hiep Pham</Select.Option>
          </Select>
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Approved Prepayment</Checkbox>
        </div>
        <Form.Item label="Valid until">
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item label="Prepayment Required Date">
          <DatePicker size="large" />
        </Form.Item>

        <Divider className="fluid-field" />
        <div className="fluid-field checkbox-field">
          <Checkbox>Specialist Bill Created</Checkbox>
        </div>
        <Form.Item label="Specialist Bill No">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Billed Date">
          <DatePicker size="large" />
        </Form.Item>

        <Divider className="fluid-field" />
        <div className="fluid-field checkbox-field">
          <Checkbox>Prepayment Paid</Checkbox>
        </div>
        <Form.Item
          label={
            <React.Fragment>
              PIC
              <button className="field-actions">Recent changes</button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Thomas Hiep Pham</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Prepayment Paid Date" required>
          <DatePicker size="large" />
        </Form.Item>
        <FieldUpload
          uploadLoading={false}
          attachments={null}
          label="Attached Payment Receipt"
        />
        <Form.Item label="Comment" className="fluid-field">
          <Input.TextArea rows={6} />
        </Form.Item>
        <div className="fluid-field">
          <Checkbox>Email Payment Receipt to Doctor</Checkbox>
        </div>
      </Form>
    );
  }
}

export default SpecialistPaymentInformation;
